import LinkedInButton from "./LinkedInButton";

export default LinkedInButton;
